import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const createOrLoginPlayer = (payload) => api.post("/players", payload).then(r => r.data);
export const getPlayer = (id) => api.get(`/players/${id}`).then(r => r.data);
export const heartbeat = (payload) => api.post("/sessions/heartbeat", payload).then(r => r.data);
export const getLeaderboard = (limit = 25) => api.get(`/leaderboard?limit=${limit}`).then(r => r.data);
export const getOverview = () => api.get("/stats/overview").then(r => r.data);
